<div class="row" style="padding-left: 15px; padding-top: 5px;">
  <div class="col-4 border-right stat-item">
    <div class="value">
      {{stats.uniqueImpressions | number}}
      <i class="app-icon-graph"></i>
    </div>
    <div class="label">{{impressionsLabel}}</div>
  </div>
  <div class="col-4 border-right stat-item">
    <div class="value">
      {{stats.uniqueViews | number}}
      <i class="app-icon-board"></i>
    </div>
    <div class="label">{{viewsLabel}}</div>
  </div>
  <div class="col-4 stat-item">
    <div class="value">
      {{stats.bids | number}}
      <i class="app-icon-tag"></i>
    </div>
    <div class="label">{{bidsLabel}}</div>
  </div>
</div>
<div class="row" *ngIf="stats.personalizedOffers">
  <div class="col-12 d-flex justify-content-center">
    <small>
      {{stats.personalizedOffers | number}}
      <ng-container *ngIf="stats.personalizedOffers > 1">ofertas personalizadas recebidas</ng-container>
      <ng-container *ngIf="stats.personalizedOffers <= 1">oferta personalizada recebida</ng-container>

      <ng-container *ngIf="stats.rejectedPersonalizedOffers"> ({{stats.rejectedPersonalizedOffers | number}}
        <ng-container *ngIf="stats.rejectedPersonalizedOffers > 1">rejeitadas</ng-container>
        <ng-container *ngIf="stats.rejectedPersonalizedOffers <= 1">rejeitada</ng-container>)
      </ng-container>
    </small>
  </div>
</div>
<div class="row" *ngIf="stats.favorites">
  <div class="col-12 d-flex justify-content-center">
    <small>Além de {{stats.favorites | number}} {{favoritePersonsLabel}} esse veículo</small>
  </div>
</div>